import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Card from '../components/shared/Card'
import Button from '../components/shared/Button'
import Spinner from '../components/shared/Spinner'
import { useAuth } from '../hooks/useAuth'
import './PurchaseSuccess.css'

export default function PurchaseSuccess() {
  const [searchParams] = useSearchParams()
  const { user } = useAuth()
  const [isVerifying, setIsVerifying] = useState(true)

  const sessionId = searchParams.get('session_id')

  useEffect(() => {
    // Give the webhook a moment to process
    const timer = setTimeout(() => {
      setIsVerifying(false)
    }, 2000)

    return () => clearTimeout(timer)
  }, [])

  if (isVerifying) {
    return (
      <div className="purchase-success">
        <div className="container">
          <Card className="success-card">
            <div className="verifying-state">
              <Spinner size="large" />
              <h2>Processing your purchase...</h2>
              <p>Please wait while we confirm your payment.</p>
            </div>
          </Card>
        </div>
      </div>
    )
  }

  return (
    <div className="purchase-success">
      <div className="container">
        <Card className="success-card">
          <div className="success-icon">✓</div>
          <h1 className="success-title">Thank You for Your Purchase!</h1>
          <p className="success-message">
            Your payment was successful and your license has been created.
            {user && ` A confirmation email has been sent to ${user.email}.`}
          </p>

          <div className="success-details">
            <h3>What's Next?</h3>
            <ol className="next-steps">
              <li>Download the PlanScan desktop app</li>
              <li>Sign in with your email to activate your license</li>
              <li>Start creating estimates!</li>
            </ol>
          </div>

          <div className="success-actions">
            <Link to="/download">
              <Button variant="primary" size="large">
                Download PlanScan
              </Button>
            </Link>
            <Link to="/dashboard/licenses">
              <Button variant="secondary">View Your Licenses</Button>
            </Link>
          </div>

          {sessionId && (
            <p className="session-reference">
              Reference: {sessionId.slice(0, 20)}...
            </p>
          )}
        </Card>
      </div>
    </div>
  )
}
